export class UrbanPlanningAbbreviation {
  abbreviation?: string;
  label?: string;
  ordinal?: number;

  constructor(abbreviation: string, label: string, ordinal: number) {
    this.abbreviation = abbreviation;
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const URBAN_PLANNING_ABBREVIATION_OPTIONS = {
  AG: new UrbanPlanningAbbreviation('AG', 'Agrarisch gebied', 1),
  BG: new UrbanPlanningAbbreviation('BG', 'Bosgebied', 2),
  DV: new UrbanPlanningAbbreviation('DV', 'Dagvaarding uitgebracht', 3),
  GDR: new UrbanPlanningAbbreviation('GDR', 'Gebied voor dagrecreatie', 4),
  GDV: new UrbanPlanningAbbreviation('GDV', 'Geen dagvaarding uitgebracht', 5),
  GVG: new UrbanPlanningAbbreviation('GVG', 'Geen vergunning uitgereikt', 6),
  GVKR: new UrbanPlanningAbbreviation(
    'GVKR',
    'Geen voorkooprecht ruimtelijke ordening aanwezig',
    7
  ),
  GVR: new UrbanPlanningAbbreviation(
    'GVR',
    'Gebied voor verblijfsrecreatie',
    8
  ),
  GVV: new UrbanPlanningAbbreviation('GVV', 'Geen verkavelingsvergunning', 9),
  IAB: new UrbanPlanningAbbreviation(
    'IAB',
    'Industriegebied voor ambachtelijke bedrijven of gebieden voor kleine en middelgrote ondernemingen',
    10
  ),
  IGB: new UrbanPlanningAbbreviation('IGB', 'Industriegebied', 11),
  LWAG: new UrbanPlanningAbbreviation(
    'LWAG',
    'Landschappelijk waardevol agrarisch gebied',
    12
  ),
  NG: new UrbanPlanningAbbreviation('NG', 'Natuurgebied', 13),
  NR: new UrbanPlanningAbbreviation('NR', 'Natuurreservaat', 14),
  PG: new UrbanPlanningAbbreviation('PG', 'Parkgebied', 15),
  VG: new UrbanPlanningAbbreviation('VG', 'Vergunning uitgereikt', 16),
  VKR: new UrbanPlanningAbbreviation(
    'VKR',
    'Voorkooprecht ruimtelijke ordening aanwezig',
    17
  ),
  VV: new UrbanPlanningAbbreviation('VV', 'Verkavelingsvergunning', 18),
  WCHE: new UrbanPlanningAbbreviation(
    'WCHE',
    'Woongebied met culturele, historische en/of esthetische waarde',
    19
  ),
  WG: new UrbanPlanningAbbreviation('WG', 'Woongebied', 20),
  WUG: new UrbanPlanningAbbreviation('WUG', 'Woonuitbreidingsgebied', 21)
};

export const URBAN_PLANNING_ABBREVIATION_OPTIONS_ARRAY = Object.values(
  URBAN_PLANNING_ABBREVIATION_OPTIONS
);
